import PhotoEdit from './PhotoEdit';
import PhotoList from './PhotoList';

export default {
  name: 'photo',
  list: PhotoList,
  edit: PhotoEdit,
};
